<div class="ui basic padded segment fitted horizontally">
  <h2 class="ui header fw-100">Reviews</h2>
  <div class="ui segment">
    <div class="ui divided two column grid">
      <div class="stretched row">
        <div
          class="eight-wide-mobile eight-wide-tablet six-wide-computer column"
        >
          <div class="ui basic segment">
            <fui-rating class="tiny yellow"></fui-rating>
            <div class="ui horizontal statistic">
              <div class="value">2,204</div>
              <div class="label"></div>
            </div>
            <p class="grey text">Based on 235 reviews</p>
          </div>
          <div class="ui basic segment">
            <button class="ui primary button">All reviews</button>
          </div>
        </div>
        <div
          class="eight-wide-mobile eight-wide-tablet ten-wide-computer column"
        >
          <div class="ui basic segment">
            <div class="ui middle aligned grid">
              <div class="left floated eight-wide column">
                <h4 class="ui header fw-100">
                  Positive
                  <div class="sub header grey text">4 stars and above</div>
                </h4>
              </div>
              <div class="right floated right aligned eight-wide column">
                <div class="ui right floated">
                  <fui-progress
                    class="indicating tiny success"
                    [value]="changingValue"
                    >{{ changingValue }}%
                  </fui-progress>
                </div>
              </div>
            </div>
          </div>
          <div class="ui basic segment">
            <div class="ui middle aligned grid">
              <div class="left floated eight-wide column">
                <h4 class="ui header fw-100">
                  Neutral
                  <div class="sub header grey text">3 stars and above</div>
                </h4>
              </div>
              <div class="right floated right aligned eight-wide column">
                <div class="ui right floated">
                  <fui-progress
                    class="indicating tiny warning"
                    [value]="changingValue"
                    >{{ changingValue }}%
                  </fui-progress>
                </div>
              </div>
            </div>
          </div>
          <div class="ui basic segment">
            <div class="ui middle aligned grid">
              <div class="left floated eight-wide column">
                <h4 class="ui header fw-100">
                  Negative
                  <div class="sub header grey text">under 2 start</div>
                </h4>
              </div>
              <div class="right floated right aligned eight-wide column">
                <div class="ui right floated">
                  <fui-progress
                    class="indicating tiny error"
                    [value]="changingValue"
                    >{{ changingValue }}%
                  </fui-progress>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
